import {
  Box,
  Chip,
  Divider,
  IconButton,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Tooltip,
  InputLabel,
  TextField,
  FormControl,
  MenuItem,
  Select,
  CircularProgress,
  Button,
  FormHelperText,
  Stack,
  Switch,
} from "@mui/material";
import ButtonCommon from "../../CommonComponents/ButtonCommon";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  addServiceStorageItem,
  createService,
  deleteService,
  deleteServiceStorageItem,
  generatePresignedUrl,
  getServiceById,
  updateService,
  updateServiceStorageItem,
} from "../../api/service";
import { showErrorToast, showSuccessToast } from "../../toastUtils";
import { Add } from "@mui/icons-material";
import { ReactComponent as EditIcon } from "../../assets/svg/edit.svg";
import { ReactComponent as Trash } from "../../assets/svg/trash.svg";
import CustomBreadcrumb from "../../CommonComponents/CommonBreadcrumb";
import Loader from "../../CommonComponents/Loader";
import CommonDrawer from "../../CommonComponents/CommonDrawer";
import CommonConfirmationModal from "../../CommonComponents/CommonConfirmationModal";
import ComponentWrapper from "../../CommonComponents/ComponentWrapper";
import { getAllCategory } from "../../api/category";

const ServiceDetails = () => {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#F9FAFB",
      color: "#000000",
      fontWeight: 600,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const IconContainer = styled(Box)({
    display: "flex",
    gap: "4px",
    "& button": {
      padding: "6px",
    },
  });

  const navigate = useNavigate();
  const { id } = useParams();
  const [selectedService, setSelectedService] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedSubOption, setSelectedSubOption] = useState("");
  const [subOptions, setSubOptions] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedStorageItem, setSelectedStorageItem] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [serviceDeleteLoading, setServiceDeleteLoading] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [isEdited, setIsEdited] = useState(false);
  const [currentService, setCurrentService] = useState(null);
  const [imageEdited, setImageEdited] = useState(false);
  const [imageError, setImageError] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [serviceIcon, setServiceIcon] = useState(null);
  const [initialImage, setInitialImage] = useState(null);
  const [formData, setFormData] = useState({});
  const [activeService, setActiveService] = useState(true);
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [category, setCategory] = useState([]);
  const [openDeleteModalServices, setOpenDeleteModalServices] = useState(false);

  const categoryOptions = (Array.isArray(category) ? category : []).map(
    (category) => ({
      id: category.category_id,
      name: category.category_name,
    })
  );

  const [errorsEdit, setErrorsEdit] = useState({
    name: "",
    category: "",
    description: "",
  });
  const [errors, setErrors] = useState({
    name: "",
    description: "",
    selectedOption: "",
    selectedSubOption: "",
  });

  // useEffect(() => {
  //   if (currentService && Object.keys(currentService).length > 0) {
  //     setFormData({
  //       name: currentService.service_name || "",
  //       category: currentService.category_id || "",
  //       description: currentService.description || "",
  //       isActive: currentService.is_deleted ? false : true
  //     });
  //     setServiceIcon({ name: currentService.service_icon });
  //     setActiveService(currentService.is_deleted ? false : true)
  //   } else {
  //     resetForm();
  //   }
  // }, [currentService]);

  useEffect(() => {
    if (
      currentService &&
      Object.keys(currentService).length > 0 &&
      category.length > 0
    ) {
      setFormData({
        name: currentService.service_name || "",
        category: currentService.category_id || "",
        description: currentService.description || "",
        isActive: currentService.is_deleted ? false : true
      });
      setServiceIcon({ name: currentService.service_icon });
      setInitialImage({ name: currentService.service_icon });
      setActiveService(currentService.is_deleted ? false : true);
    }
  }, [currentService, category]);

  const fetchAllCategories = async () => {
    try {
      setCategoryLoading(true);
      const res = await getAllCategory(1, 100);
      if (res?.status_code === 200 || res?.status_code === 404) {
        const filterCategories = res?.data?.categories.filter(categorie => categorie.status === 'active')
        setCategory(filterCategories);
      }
    } catch (err) {
      showErrorToast(err);
    } finally {
      setCategoryLoading(false);
    }
  };

  useEffect(() => {
    // if (openEdit) {
    fetchAllCategories();
    // }
  }, []);


  // const resetForm = () => {
  //   setFormData({
  //     name: "",
  //     description: "",
  //     duration: "",
  //     durationValue: "",
  //   });
  //   setServiceIcon(null);
  //   setErrorsEdit({});
  // };

  const validateForm = () => {
    const newErrors = {};

    const nameRegex = /^[^\s]+$/;
    if (!name.trim()) {
      newErrors.name = "Name is required";
    } else if (!nameRegex.test(name.trim())) {
      newErrors.name = "Input cannot contain spaces.";
    }

    if (!description.trim()) {
      newErrors.description = "Description is required";
    }

    if (!selectedOption) {
      newErrors.selectedOption = "Duration option is required";
    }

    if (!selectedSubOption) {
      newErrors.selectedSubOption = "Duration value is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if no errors
  };

  const handleSelectChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);

    // Update the second select options based on the selected option
    switch (value) {
      case "year":
        setSubOptions(Array.from({ length: 10 }, (_, i) => i + 1)); // Years 1-10
        break;
      case "month":
        setSubOptions(Array.from({ length: 12 }, (_, i) => i + 1)); // Months 1-12
        break;
      case "day":
        setSubOptions(Array.from({ length: 31 }, (_, i) => i + 1)); // Days 1-31
        break;
      case "hour":
        setSubOptions(Array.from({ length: 24 }, (_, i) => i + 1)); // Hours 1-24
        break;
      default:
        setSubOptions([]);
        break;
    }
  };

  const handleSubmit = async (event) => {
    if (!validateForm()) {
      return;
    }
    event.preventDefault();
    const data = {
      storage_item: [
        {
          name,
          description,
          duration: `${selectedSubOption} ${selectedOption}`,
        },
      ],
    };

    const updatepayload = {
      storage_item: [
        {
          id: selectedStorageItem?.id,
          name,
          description,
          duration: `${selectedSubOption} ${selectedOption}`, // Format duration as "X Option"
        },
      ],
    };

    try {
      setLoading(true);
      if (isEditMode) {
        const response = await updateServiceStorageItem(
          selectedService?.service_id,
          updatepayload
        );
        if (response.status_code === 201) {
          setOpen(false);
          setIsEditMode(false);
          setLoading(false);
          navigate("/master/services");
          showSuccessToast(response.message);
          // You can show success messages or reset the form here
        } else if (response?.status_code === 400) {
          setOpen(false);
          showErrorToast(response?.message);
          setLoading(false);
        } else {
          setOpen(false);
          // You can show error messages to the user
        }
      } else {
        setLoading(true);
        const response = await addServiceStorageItem(
          data,
          selectedService?.service_id
        );
        if (response.status_code === 201 || response.status_code === 404) {
          setName("");
          setDescription("");
          setSelectedOption("");
          setSubOptions([]);
          setOpen(false);
          navigate("/master/services");
          showSuccessToast(response.message);
        } else if (response?.status_code === 400) {
          setOpen(false);
          showErrorToast(response?.message);
          setLoading(false);
        } else {
          setOpen(false);
        }
      }
    } catch (error) {
      setOpen(false);
      setLoading(false);
      // Handle any network errors
    }
  };

  const breadcrumbItems = [
    {
      text: "Master Services",
      href: "/master/services",
      onClick: () => navigate("/master/services"),
    },
    {
      text: selectedService?.service_name,
    },
  ];

  const formatDuration = (duration) => {
    if (!duration) return "-";

    const [numericValue, unit] = duration.split(" "); // Split "6 month" into [6, "month"]
    const num = parseInt(numericValue, 10);

    if (isNaN(num) || !unit) return duration; // If parsing fails, return original

    return num > 1 ? `${num} ${unit}s` : duration; // Append "s" for plural
  };

  const fetchServiceById = async () => {
    setLoading(true);
    try {
      const res = await getServiceById(id);
      if (res.status_code === 200) {
        setLoading(false);
        setSelectedService(res.data);
        setCurrentService(res.data)
      } else {
        setLoading(false);
        showErrorToast(res.message);
      }
    } catch (err) {
      setLoading(false);
      showErrorToast(err);
    }
  };

  useEffect(() => {
    fetchServiceById();

    //eslint-disable-next-line
  }, []);

  // useEffect(() => {
  //   if (openEdit) {
  //     fetchServiceById();
  //   }

  //   //eslint-disable-next-line
  // }, [openEdit]);

  const openEditDrawer = (storageItem) => {
    setIsEditMode(true);
    setName(storageItem.name);
    setDescription(storageItem.description);
    const [numericDuration, unitDuration] = storageItem.duration.split(" ");
    setSelectedOption(unitDuration);
    let updatedSubOptions = [];
    switch (unitDuration) {
      case "year":
        updatedSubOptions = Array.from({ length: 10 }, (_, i) => i + 1);
        break;
      case "month":
        updatedSubOptions = Array.from({ length: 12 }, (_, i) => i + 1);
        break;
      case "day":
        updatedSubOptions = Array.from({ length: 31 }, (_, i) => i + 1);
        break;
      case "hour":
        updatedSubOptions = Array.from({ length: 24 }, (_, i) => i + 1);
        break;
      default:
        updatedSubOptions = [];
        break;
    }
    setSubOptions(updatedSubOptions);
    if (updatedSubOptions.includes(Number(numericDuration))) {
      setSelectedSubOption(numericDuration);
    } else {
      setSelectedSubOption(""); // Fallback if value isn't valid
    }
    setTimeout(() => {
      setOpen(true);
    }, 500);
  };

  const handleDeleteService = async () => {
    setServiceDeleteLoading(true)
    try {
      const response = await deleteService(id);

      if (response.success) {
        showSuccessToast(response.message);
        navigate("/master/services");
      } else {
        showErrorToast(response.message);
      }
    } catch (error) {
      console.error("Error deleting service:", error);
      showErrorToast(error.message || "Something went wrong while deleting service.");
    } finally {
      setServiceDeleteLoading(false)
    }
  };
  const validateFormEdit = () => {
    let isValid = true;
    let formErrors = {
      name: "",
      category: "",
      description: "",
      storageItems: "",
    };

    // Validate Service Name
    if (!formData?.name?.trim()) {
      formErrors.name = "Service Name is required.";
      isValid = false;
    }

    // Validate Selected Category
    if (!formData?.category) {
      formErrors.category = "Category selection is required.";
      isValid = false;
    }

    // Validate Service Description
    if (!formData?.description?.trim()) {
      formErrors.description = "Service Description is required.";
      isValid = false;
    }

    setErrorsEdit(formErrors);
    return isValid;
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      const res = await deleteServiceStorageItem(
        selectedStorageItem.name,
        selectedService.service_id
      );
      if (res.status_code === 201) {
        await getServiceById(selectedService.service_id);
        setSelectedService(res.data);
        setOpen(false);
        showSuccessToast(res?.message);
        setLoading(false);
        navigate('/master/services')
      } else {
        setOpen(false);
        showErrorToast(res?.message);
        setLoading(false);
      }
    } catch (error) {
      showErrorToast("Failed to create category:", error);
      setLoading(false);
    }
  };

  const handleChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    setIsEdited(true)
  };

  const handleServiceSwitchChange = (e) => {
    setActiveService(e.target.checked);
    // if (!e.target.checked) {
    //   setActiveStorageItems(false); // Disable storage items if the service is turned off
    //   setStorageItems([]); // Clear storage items when service is inactive
    // }
    setIsEdited(true)
  };

  const handleSubmitEdit = async (e) => {
    e.preventDefault(); // Always at the top

    if (!serviceIcon) {
      setImageError('Image is required')
      return
    } else {
      setImageError(null)
    }

    if (!validateFormEdit()) {
      return;
    }

    setSubmitLoading(true);

    try {
      // Handle file upload if a service icon was selected
      let iconFileName = currentService?.service_icon || "";

      if (currentService && serviceIcon && initialImage?.name !== serviceIcon?.name) {
        const presignedUrlResponse = await generatePresignedUrl(serviceIcon.name);

        if (presignedUrlResponse?.status_code !== 200) {
          throw new Error(
            presignedUrlResponse?.message || "Failed to generate upload URL"
          );
        }

        const { url, file_name } = presignedUrlResponse.data;
        iconFileName = file_name;

        const uploadResponse = await fetch(url, {
          method: "PUT",
          body: serviceIcon,
          headers: {
            "Content-Type": serviceIcon.type,
          },
        });

        if (!uploadResponse.ok) {
          throw new Error(
            `File upload failed with status: ${uploadResponse.status}`
          );
        }
      }

      // Step 3: Create or update service with the file name
      const payload = {
        service_icon: iconFileName,
        service_name: formData.name,
        description: formData.description,
        category_id: formData.category,
        is_deleted: !activeService,
      };

      let response;
      // if (Object.keys(currentService).length > 0) {
      if (currentService) {
        response = await updateService(currentService.service_id, payload);
      } else {
        response = await createService(payload);
      }

      if (response?.status_code === 201) {
        showSuccessToast(response.message);
        navigate("/master/services");
        setOpenEdit(false);
      } else {
        showErrorToast(response.message);
      }

    } catch (error) {
      console.error("Service submit error:", error);
      showErrorToast(
        error.message || "There was an error submitting the form."
      );
    } finally {
      setSubmitLoading(false);
      setImageEdited(false)
      setIsEdited(false)
    }
  };

  return (
    <ComponentWrapper>
      {/* <Stack sx={{ maxWidth: "1000px" }}> */}
      {loading ? (
        <Loader />
      ) : (
        <>
          <Box sx={{ mb: 2 }}>
            <CustomBreadcrumb
              items={breadcrumbItems}
              onBackClick={() => {
                navigate("/master/services");
              }}
            />
          </Box>
          <Box>
            {/* Header Section */}
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <Box sx={{ display: "flex", alignItems: "center", flex: 1 }}>
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mr: 1,
                  }}
                >
                  <img
                    src={
                      selectedService?.service_icon !== null
                        ? `${process.env.REACT_APP_SERVICE_ICON_URL}/${selectedService?.service_icon}`
                        : "/imageps/default.svg"
                    }
                    alt={`${selectedService?.service_name} Icon`}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain",
                    }}
                  />
                </Box>
                <Typography variant="h6" fontWeight="bold" color="#525455">
                  {selectedService?.service_name}
                </Typography>
                <Chip
                  variant="filled"
                  label={selectedService?.category_name}
                  sx={{
                    fontSize: "15px",
                    fontWeight: 400,
                    background: "#E6E7EB",
                    borderRadius: "4px",
                    mr: 2,
                    ml: 2,
                  }}
                />
                <Typography
                  component="span"
                  sx={{
                    fontSize: "14px",
                    color: "#5f6368",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {selectedService?.storage_item?.length > 0
                    ? selectedService?.storage_item?.length
                    : 0}{" "}
                  Storage Items
                </Typography>
              </Box>
              <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                <ButtonCommon disabled={serviceDeleteLoading} onClick={() => setOpenEdit(true)}>Edit</ButtonCommon>
                <ButtonCommon disabled={serviceDeleteLoading || selectedService?.status === 'inactive'} onClick={() => setOpenDeleteModalServices(true)}>{serviceDeleteLoading ? <CircularProgress /> : 'Delete'}</ButtonCommon>
              </Box>
            </Box>
            {/* Description */}
            <Typography
              sx={{
                fontSize: "14px",
                color: "#5f6368",
                mb: 2,
                maxWidth: "800px",
              }}
            >
              {selectedService?.description}
            </Typography>
            <Divider />
            {/* Service Storage Items Section */}
            <Box sx={{ mb: 4, mt: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "20px",
                    fontWeight: 700,
                    color: "#525455",
                  }}
                >
                  Service Storage Items
                </Typography>
                <ButtonCommon
                  icon={<Add />}
                  onClick={() => {
                    setIsEditMode(false);
                    setName("");
                    setDescription("");
                    setSelectedOption("");
                    setSelectedSubOption("");
                    setOpen(true);
                  }}
                >
                  Add
                </ButtonCommon>
              </Box>

              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#989898",
                  mb: 2,
                }}
              >
                Storage items that belong to this service.
              </Typography>

              <TableContainer
                // component={Paper}
                // elevation={0}
                // sx={{
                //   border: "1px solid #dadce0",
                //   borderRadius: "8px",
                //   mb: 4,
                // }}
                component={Paper}
                variant="outlined"
                sx={{ borderRadius: "12px" }}
              >
                <Table>
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>
                        Name
                      </StyledTableCell>
                      <StyledTableCell>
                        Description
                      </StyledTableCell>
                      <StyledTableCell>
                        Duration
                      </StyledTableCell>
                      <StyledTableCell sx={{ textAlign: 'center' }}>
                        Action
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedService?.storage_item?.length > 0 ? (
                      (Array.isArray(selectedService?.storage_item)
                        ? selectedService?.storage_item
                        : []
                      )?.map((item, index) => (
                        <TableRow key={index}>
                          <StyledTableCell>
                            {item?.name}
                          </StyledTableCell>
                          <StyledTableCell>
                            <Tooltip title={item?.description || "-"} arrow>
                              <Typography
                                noWrap
                                sx={{
                                  maxWidth: 550, // Adjust the width as needed
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {item?.description ? item?.description : "-"}
                              </Typography>
                            </Tooltip>
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {item?.duration
                              ? formatDuration(item?.duration)
                              : "-"}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            <IconContainer justifyContent="center">
                              <IconButton
                                size="small"
                                sx={{
                                  color: "#5f6368",
                                  "&:hover": {
                                    backgroundColor: "#f8f9fa",
                                  },
                                }}
                                onClick={() => {
                                  openEditDrawer(item);
                                  setSelectedStorageItem(item);
                                }}
                              >
                                <EditIcon size={16} />
                              </IconButton>
                              <IconButton
                                size="small"
                                sx={{
                                  color: "#5f6368",
                                  "&:hover": {
                                    backgroundColor: "#f8f9fa",
                                  },
                                }}
                                onClick={() => {
                                  setOpenDeleteModal(true);
                                  setSelectedStorageItem(item);
                                }}
                              >
                                <Trash size={16} />
                              </IconButton>
                            </IconContainer>
                          </StyledTableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <StyledTableCell colSpan={4} align="center">
                          <Typography variant="body2" color="textSecondary">
                            No storage items available.
                          </Typography>
                        </StyledTableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* Uncategorised Section */}
              {/* <Box sx={{ mt: 2 }}>
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: 700,
                    color: "#3c4043",
                    mb: 1,
                  }}
                >
                  Uncategorised
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#989898",
                  }}
                >
                  Storage items not assigned to any category or service.
                </Typography>
                <TableContainer
                  component={Paper}
                  elevation={0}
                  sx={{
                    border: "1px solid #dadce0",
                    borderRadius: "8px",
                    mb: 4,
                    mt: 2,
                  }}
                >
                  <Table>
                    <TableHead>
                      <TableRow>
                        <StyledTableCell className="header" align="left">
                          Name
                        </StyledTableCell>
                        <StyledTableCell className="header" align="left">
                          Description
                        </StyledTableCell>
                        <StyledTableCell className="header" align="left">
                          Duration
                        </StyledTableCell>
                        <StyledTableCell className="header" align="left">
                          Action
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {selectedService?.uncategorized?.length > 0 ? (
                        (Array.isArray(selectedService?.uncategorized)
                          ? selectedService?.uncategorized
                          : []
                        )?.map((item, index) => (
                          <TableRow key={index}>
                            <StyledTableCell align="left">
                              {item?.name}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {item?.description ? item?.description : "-"}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {item?.duration ? item?.duration : "-"}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              <IconContainer justifyContent="left">
                                <IconButton
                                  size="small"
                                  sx={{
                                    color: "#5f6368",
                                    "&:hover": {
                                      backgroundColor: "#f8f9fa",
                                    },
                                  }}
                                >
                                  <Add size={16} />
                                </IconButton>
                                <IconButton
                                  size="small"
                                  sx={{
                                    color: "#5f6368",
                                    "&:hover": {
                                      backgroundColor: "#f8f9fa",
                                    },
                                  }}
                                >
                                  <DeleteOutline size={16} />
                                </IconButton>
                              </IconContainer>
                            </StyledTableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <StyledTableCell colSpan={4} align="center">
                            <Typography variant="body2" color="textSecondary">
                              No storage items available.
                            </Typography>
                          </StyledTableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box> */}
            </Box>
          </Box>
        </>
      )}
      <CommonDrawer
        open={open}
        onClose={() => setOpen(false)}
        title={isEditMode ? "Edit Storage Item" : "Add Storage Item"} // Change title based on mode
        subTitle={
          isEditMode
            ? "Edit this storage item. Once you save changes, they will be shown to your website users if they opt for managing cookie preferences."
            : "Add new storage item to your service. This will be shown to your website users if they opt for managing cookie preferences."
        }
        primaryButton={{
          label: isEditMode ? "Update" : "Create", // Change button text based on mode
          onClick: handleSubmit,
          sx: { px: 2 },
        }}
        cancelButtonLabel="Cancel"
        drawerWidth={400}
      >
        <Box component="form" onSubmit={handleSubmit}>
          <Typography variant="body1" fontWeight="600" color="#525455">
            Default Settings
          </Typography>

          {/* Category Name Field */}
          <InputLabel shrink htmlFor="name" required sx={{ mt: 2 }}>
            Name
          </InputLabel>
          <TextField
            fullWidth
            id="name"
            placeholder="Name"
            variant="outlined"
            size="small"
            sx={{ mb: 2 }}
            value={name}
            onChange={(e) => setName(e.target.value)} // Handle change of name
            error={Boolean(errors.name)}
            helperText={errors.name}
          />

          {/* Category Description Field */}
          <InputLabel shrink htmlFor="description" required>
            Description of Service
          </InputLabel>
          <TextField
            fullWidth
            id="description"
            placeholder="Description"
            multiline
            rows={3}
            variant="outlined"
            size="small"
            sx={{ mb: 2 }}
            value={description}
            onChange={(e) => setDescription(e.target.value)} // Handle change of description
            error={Boolean(errors.description)}
            helperText={errors.description}
          />

          {/* Duration Fields */}
          <InputLabel shrink htmlFor="duration" required>
            Duration
          </InputLabel>
          <Box sx={{ display: "flex", flexDirection: 'column' }}>
            {/* First Select Dropdown */}
            <FormControl fullWidth>
              <InputLabel id="select-option-label">Select Option</InputLabel>
              <Select
                labelId="select-option-label"
                value={selectedOption}
                onChange={handleSelectChange}
                label="Select Option"
              >
                <MenuItem value="year">Year</MenuItem>
                <MenuItem value="month">Month</MenuItem>
                <MenuItem value="day">Day</MenuItem>
                <MenuItem value="hour">Hour</MenuItem>
              </Select>
            </FormControl>
            {errors.selectedOption && (
              <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 2 }}>
                {errors.selectedOption}
              </Typography>
            )}

            {/* Second Select Dropdown */}
            {selectedOption && (
              <FormControl fullWidth>
                <InputLabel id="select-sub-option-label">
                  Select {selectedOption}
                </InputLabel>
                <Select
                  labelId="select-sub-option-label"
                  value={selectedSubOption || "dfdgdfgfd"}
                  onChange={(e) => setSelectedSubOption(e.target.value)}
                  label={`Select ${selectedOption}`}
                >
                  {subOptions.map((option, index) => (
                    <MenuItem key={index} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
                {errors.selectedSubOption && (
                  <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                    {errors.selectedSubOption}
                  </Typography>
                )}
              </FormControl>
            )}
          </Box>
        </Box>
      </CommonDrawer>

      <CommonDrawer
        open={openEdit}
        onClose={() => {
          setOpenEdit(false);
          setCurrentService(null);
          setImageEdited(false)
          setIsEdited(false)
        }}
        title={"Update Service"}
        subTitle="Sort cookies with specific jobs, helping users personalize their cookie choices."
        primaryButton={{
          // label: submitLoading ? (
          //   <CircularProgress size={20} />
          // ) : currentService ? (
          //   "Update"
          // ) : (
          //   "Create"
          // ),
          label: submitLoading ? (
            <CircularProgress size={20} />
          ) : "Update",
          onClick: handleSubmitEdit,
          sx: { px: 2 },
          disabled: !isEdited
        }}
        cancelButtonLabel="Cancel"
        drawerWidth={400}
      >
        <Box component="form" onSubmit={handleSubmit}>
          {/* Default Settings Section */}
          <Typography
            variant="subtitle2"
            sx={{ fontWeight: 600, color: "#525455", mb: 2 }}
          >
            Default Settings
          </Typography>

          <Box sx={{ mb: 3 }}>
            <InputLabel
              required
              sx={{
                color: "#525455",
                mb: 1,
                fontSize: "0.875rem",
                "& .MuiFormLabel-asterisk": {
                  color: "red",
                },
              }}
            >
              Service Icon (PNG, JPG, SVG)
            </InputLabel>
            <Box>
              <Button
                variant="outlined"
                component="label"
                sx={{ textTransform: "none" }}
              >
                Upload
                <input
                  type="file"
                  accept=".png,.jpg,.jpeg,.svg"
                  hidden
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (!file) return;

                    const img = new Image();
                    const objectUrl = URL.createObjectURL(file);

                    img.onload = () => {
                      if (img.width > 40 || img.height > 40) {
                        setImageError("Image must be 40x40 pixels or smaller");
                        setServiceIcon(null);
                        setImageEdited(false);
                        setIsEdited(false);
                      } else {
                        setServiceIcon(file);
                        setImageEdited(true);
                        setImageError(null);
                        setIsEdited(true);
                      }
                      URL.revokeObjectURL(objectUrl); // cleanup
                    };

                    img.onerror = () => {
                      setImageError("Invalid image file.");
                      setServiceIcon(null);
                      URL.revokeObjectURL(objectUrl); // cleanup
                    };

                    img.src = objectUrl;
                  }}
                />
              </Button>
              <FormHelperText error>{imageError}</FormHelperText>
            </Box>
            {serviceIcon && (
              <Stack sx={{ marginTop: 1 }}>
                <Box
                  component="img"
                  src={
                    imageEdited
                      ? URL.createObjectURL(serviceIcon)
                      : `${process.env.REACT_APP_SERVICE_ICON_URL}/${serviceIcon.name}`
                  }
                  sx={{ width: '50px' }}
                />
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                  Selected: {serviceIcon.name}
                </Typography>
              </Stack>
            )}

          </Box>

          {/* Service Name Field */}
          <Box sx={{ mb: 3 }}>
            <InputLabel
              required
              sx={{
                color: "#525455",
                mb: 1,
                fontSize: "0.875rem",
                "& .MuiFormLabel-asterisk": {
                  color: "red",
                },
              }}
            >
              Name
            </InputLabel>
            <TextField
              fullWidth
              name="name"
              size="small"
              placeholder="Google Analytics"
              value={formData.name}
              onChange={(e) => handleChange("name", e.target.value)}
              sx={{ mb: 0.5 }}
              error={!!errorsEdit.name}
              helperText={errorsEdit.name}
            />
            <Typography variant="caption" color="text.secondary">
              You can add * to pattern match & capture all items that follow
              this pattern.
            </Typography>
          </Box>

          {/* Category Selection */}
          <Box sx={{ mb: 3 }}>
            <InputLabel
              required
              sx={{
                color: "#525455",
                mb: 1,
                fontSize: "0.875rem",
                "& .MuiFormLabel-asterisk": {
                  color: "red",
                },
              }}
            >
              Select Category
            </InputLabel>
            {/* <Select
              value={formData.category}
              onChange={(e) => handleChange("category", e.target.value)}
              fullWidth
              size="small"
              error={!!errorsEdit.category}
            >
              {categoryLoading ?
                <MenuItem sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}><CircularProgress size={20} /></MenuItem> :
                categoryOptions && categoryOptions.length > 0 && categoryOptions.map((category) => (
                  <MenuItem key={category.id} value={category.id}>
                    {category.name}
                  </MenuItem>
                ))}
            </Select> */}
            <Select
              value={formData.category?.toString() || ""}
              onChange={(e) => handleChange("category", e.target.value)}
              fullWidth
              size="small"
              error={!!errorsEdit.category}
            >

              {categoryLoading ?
                <MenuItem sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}><CircularProgress size={20} /></MenuItem> :
                categoryOptions && categoryOptions.length > 0 && categoryOptions.map((category) => (
                  <MenuItem key={category.id} value={category.id.toString()}>
                    {category.name}
                  </MenuItem>
                ))}
            </Select>

            <FormHelperText error>{errorsEdit.category}</FormHelperText>
          </Box>

          {/* Service Description */}
          <Box sx={{ mb: 4 }}>
            <InputLabel
              required
              sx={{
                color: "#525455",
                mb: 1,
                fontSize: "0.875rem",
                "& .MuiFormLabel-asterisk": {
                  color: "red",
                },
              }}
            >
              Description of Service
            </InputLabel>
            <TextField
              fullWidth
              multiline
              rows={4}
              value={formData.description}
              onChange={(e) => handleChange("description", e.target.value)}
              placeholder="Description"
              error={!!errorsEdit.description}
              helperText={errorsEdit.description}
            />
          </Box>



          {currentService && Object.keys(currentService).length > 0 && (
            <>
              <Divider sx={{ mt: 2, mb: 2 }} />
              <Box sx={{ mb: 2 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 1,
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 600, color: "#525455" }}
                  >
                    Activate Service
                  </Typography>
                  <Switch
                    color="primary"
                    checked={activeService}
                    onChange={handleServiceSwitchChange}
                  />
                </Box>
                <Typography variant="body2" color="text.secondary">
                  If disabled, this service will not be shown to any visitors.
                </Typography>
              </Box>
            </>
          )}
        </Box>
      </CommonDrawer>

      {/* Delete Modal For Storage*/}
      <CommonConfirmationModal
        open={openDeleteModal}
        onClose={() => setOpenDeleteModal(false)}
        title="Delete Storage Item"
        description={`Are you sure you want to delete the storage Item "${selectedStorageItem?.name}"? This action cannot be undone.`}
        onConfirm={() => {
          handleDelete(selectedStorageItem);
          setOpenDeleteModal(false);
        }}
        loading={loading}
        confirmLabel="Delete"
        cancelLabel="Cancel"
      />

      {/* Delete Modal For Services*/}
      <CommonConfirmationModal
        open={openDeleteModalServices}
        onClose={() => setOpenDeleteModalServices(false)}
        title="Delete Services"
        description={`Are you sure you want to delete the services"?`}
        onConfirm={() => {
          handleDeleteService(id);
          setOpenDeleteModalServices(false);
        }}
        loading={loading}
        confirmLabel="Delete"
        cancelLabel="Cancel"
      />
      {/* </Stack> */}
    </ComponentWrapper>
  );
};
export default ServiceDetails;
